import React from 'react';

import { TextField, type TextFieldProps } from '@mui/material';

import { fieldLengthProps } from '../constants';

import { IMPORT_NAME_LIMITS, type ImportNameEdits, importNameKey, resolveImportedName } from './excelImportModel';

type ImportNameFieldProps = Pick<TextFieldProps, 'disabled' | 'inputProps' | 'label'> & {
  kind: keyof typeof IMPORT_NAME_LIMITS;
  original: string;
  nameEdits: ImportNameEdits;
  onNameChange: (key: string, name: string) => void;
};

export default function ImportNameField({
  kind,
  original,
  nameEdits,
  onNameChange,
  ...fieldProps
}: ImportNameFieldProps) {
  const key = importNameKey(kind, original);
  return (
    <TextField
      {...fieldProps}
      {...fieldLengthProps(resolveImportedName(kind, original, nameEdits), IMPORT_NAME_LIMITS[kind])}
      fullWidth
      multiline
      onChange={(event) => onNameChange(key, event.target.value)}
      size="small"
      value={nameEdits[key] ?? original}
    />
  );
}
